import React from "react";
import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { Tooltip } from "@mui/material";
import { TextEntryFormControl } from "../TextEntryFormControl";
import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { PropertyEditorCollapse } from "../../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";

export class ImageFormControl extends TextEntryFormControl {
    readonly __type: string = "Image";
    link?: string;
    staticImageLink: boolean = true;
    tooltip: string = "";

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        return;
    }

    render() {
        const customWidth = this.fullWidth ? "100%" : this.width ? `${this.width}px` : "200px";

        let imageSource = this.staticImageLink
            ? this.link
                ? this.link
                : ""
            : this.valueName
              ? this.getFormDataValue(this.valueName)
              : "";

        return (
            <div>
                <Tooltip title={this.tooltip}>
                    <input
                        type="image"
                        src={imageSource}
                        width={customWidth}
                        data-testid="image"
                        value={this.valueName ? this.getFormDataValue(this.valueName) : ""}
                        alt=""
                    />
                </Tooltip>
            </div>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XImageFieldEditUi editMe={this} />;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "link", "staticImageLink", "tooltip");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "link", "staticImageLink", "tooltip");
    }
}

function XImageFieldEditUi(props: { editMe: ImageFormControl }) {
    return (
        <UISpacedBoxContent>
            <PropertyEditorText
                label={"Tooltip"}
                propertyName={"tooltip"}
                editObject={props.editMe}
            />
            <PropertyEditorBoolean
                label={"Static Image Link"}
                propertyName={"staticImageLink"}
                editObject={props.editMe}
            />

            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"staticImageLink"}
            >
                <PropertyEditorText
                    label={"Static Image Link"}
                    propertyName={"link"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>

            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"staticImageLink"}
                showIfFalse={true}
            >
                <PropertyEditorText
                    editObject={props.editMe}
                    label={"Value Name"}
                    propertyName={"valueName"}
                />
            </PropertyEditorCollapse>

            <PropertyEditorBoolean
                label={"Full Width"}
                propertyName={"fullWidth"}
                editObject={props.editMe}
            />

            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"fullWidth"}
                showIfFalse={true}
            >
                <PropertyEditorInteger
                    label={"Width"}
                    propertyName={"width"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>
        </UISpacedBoxContent>
    );
}
